import { createContext } from "react";

const InitializeContext = createContext();
export default InitializeContext;